import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';
import { SKIP_GLOBAL_LOADING } from './http-context.tokens';
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private activeRequests: number = 0;
  constructor(private loadingService: LoadingService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.context.get(SKIP_GLOBAL_LOADING)) {
      return next.handle(request);
    }

    this.activeRequests++;
    this.loadingService.loading();

    return next.handle(request).pipe(
      finalize(() => {
        if (this.activeRequests > 0) {
          this.activeRequests--;
        }
        if (this.activeRequests <= 0) {
          this.loadingService.loaded();
        }
      }),
    );
  }
}
